import { PDFDocument } from "pdf-lib";

export function triggerPdfDownload(base64Payload: string, fileName: string) {
  const sanitizedPayload = base64Payload.trim();
  const cleanedPayload = sanitizedPayload.includes(",")
    ? (sanitizedPayload.split(",").pop() ?? "")
    : sanitizedPayload;
  const binaryString = window.atob(cleanedPayload);
  const bytes = new Uint8Array(binaryString.length);

  for (let index = 0; index < binaryString.length; index += 1) {
    bytes[index] = binaryString.charCodeAt(index);
  }

  const blob = new Blob([bytes], { type: "application/pdf" });
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(objectUrl);
}

function getPdfStem(fileName: string) {
  return fileName.replace(/\.pdf$/iu, "");
}

export async function getPdfPageCount(file: File): Promise<number> {
  const bytes = await file.arrayBuffer();
  const pdfDocument = await PDFDocument.load(bytes);
  return pdfDocument.getPageCount();
}

export async function buildPdfWithSelectedPages(
  file: File,
  selectedPageIndices: number[],
): Promise<File> {
  const sourceBytes = await file.arrayBuffer();
  const sourceDocument = await PDFDocument.load(sourceBytes);
  const normalizedPageIndices = [...new Set(selectedPageIndices)]
    .filter(
      (pageIndex) =>
        pageIndex >= 0 && pageIndex < sourceDocument.getPageCount(),
    )
    .sort((left, right) => left - right);

  if (normalizedPageIndices.length === 0) {
    throw new Error("Select at least one PDF page.");
  }

  const outputDocument = await PDFDocument.create();
  const copiedPages = await outputDocument.copyPages(
    sourceDocument,
    normalizedPageIndices,
  );

  copiedPages.forEach((page) => {
    outputDocument.addPage(page);
  });

  const outputBytes = await outputDocument.save();
  return new File(
    [outputBytes],
    `${getPdfStem(file.name)} - selected-pages.pdf`,
    {
      type: "application/pdf",
      lastModified: Date.now(),
    },
  );
}
